//  Modules from the React eco-system
import { useState, useEffect, useContext } from "react"

// Navigation
import regionsMainRoutes from "../routes/mains/regions-main.route"
import { Route, Switch, useHistory } from "react-router-dom"

// Own components
import SubPageNavbar from "../components/navigation/subpage-navbar.component"
import Loader from "../components/loader.component"

// Redux, store
import { setPageName } from "../store/pageSlice"
import { useDispatch } from "react-redux"
import { UserContext } from "../store/UserProvider"

// Axios
import axiosClient from "../api/api"

// Interfaces, enums
import { IRegion } from "../interfaces/cubes"
import { ISubPageRoute } from "../interfaces/pages"
import { ERoles } from "../constants/enum"

function Regions() {
    //Logged in user
    const { user } = useContext(UserContext)

    const dispatch = useDispatch()
    const history = useHistory()

    // regions from the fetch
    const [regions, setRegions] = useState<IRegion[]>([])

    const [isLoading, setIsLoading] = useState(false)

    useEffect(() => {
        // set page name in the navbar
        dispatch(setPageName({ pageName: "Regions", pageUrl: "/admin/regions/main", subPageName: "" }))

        // fetch regions
        fetchRegions()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    /**
     * fetch regions from the backend
     */
    async function fetchRegions() {
        setIsLoading(true)
        try {
            const response = await axiosClient.get("/region?populateFields[]=cubes")
            setRegions(response.data)
        } catch (error) {
            console.log("Failed to fetch regions")
            history.push("/admin/404")
        }
        setIsLoading(false)
    }

    return (
        <div className="regions-page">
            {isLoading ? (
                <Loader />
            ) : (
                <>
                    <SubPageNavbar
                        routes={regionsMainRoutes.filter((route: ISubPageRoute) => {
                            return route.permission?.includes(user.role as ERoles)
                        })}
                    />

                    <Switch>
                        {regionsMainRoutes
                            .filter((route: ISubPageRoute) => {
                                return route.permission?.includes(user.role as ERoles)
                            })
                            .map((route: ISubPageRoute, key: number) => {
                                return (
                                    <Route
                                        key={key}
                                        path={route.path}
                                        exact
                                        render={() => {
                                            return (
                                                <div>
                                                    <route.component regions={regions} setRegions={setRegions} {...route.props} />
                                                </div>
                                            )
                                        }}
                                    />
                                )
                            })}
                    </Switch>
                </>
            )}
        </div>
    )
}

export default Regions
